import { focusFirst, tabbables } from "./focus.js";
import { syncInert } from "./inert.js";
//#region src/components/_overlay/stack.ts
var layers = [];
function isAncestor(ancestor, layer) {
	for (let current = layer.parent(); current; current = current.parent()) if (current === ancestor) return true;
	return false;
}
/**
* Adds a layer. It goes on top, except below any layer it opened itself: when a layer
* and its child open in the same render, React registers the child first.
*/
function registerLayer(layer) {
	const firstDescendant = layers.findIndex((other) => isAncestor(layer, other));
	if (firstDescendant === -1) layers.push(layer);
	else layers.splice(firstDescendant, 0, layer);
	if (layers.length === 1) listen();
	syncInert(layers);
	return () => {
		const index = layers.indexOf(layer);
		if (index !== -1) layers.splice(index, 1);
		if (layers.length === 0) unlisten();
		syncInert(layers);
	};
}
var within = (node, element) => !!element && node instanceof Node && element.contains(node);
/** True if `node` is inside `layer` or any layer above it. */
function inLayerOrAbove(layer, node) {
	return layers.slice(layers.indexOf(layer)).some((other) => within(node, other.root));
}
function topTrap() {
	return layers.findLast((layer) => layer.trapFocus);
}
function onKeyDown(event) {
	if (event.key === "Escape") {
		if (event.defaultPrevented || event.isComposing) return;
		if (layers.at(-1)?.dismiss("escape")) event.preventDefault();
		return;
	}
	if (event.key === "Tab") trapTab(event);
}
function onPointerDown(event) {
	const top = layers.at(-1);
	if (!top) return;
	const target = event.target;
	if (within(target, top.content() ?? top.root) || top.inside().some((element) => within(target, element))) return;
	top.dismiss("outside");
}
/** Tab and Shift+Tab wrap around inside the topmost trapping layer. */
function trapTab(event) {
	const trap = topTrap();
	if (!trap) return;
	const active = document.activeElement;
	if (!within(active, trap.root) && inLayerOrAbove(trap, active)) return;
	const items = tabbables(trap.root);
	if (items.length === 0) {
		event.preventDefault();
		trap.root.focus();
		return;
	}
	const first = items[0];
	const last = items.at(-1);
	const outside = !within(active, trap.root);
	if (event.shiftKey && (outside || active === first || active === trap.root)) {
		event.preventDefault();
		last?.focus();
	} else if (!event.shiftKey && (outside || active === last)) {
		event.preventDefault();
		first?.focus();
	}
}
/** Focus that escapes the topmost trap (programmatically, say) is brought back. */
function onFocusIn(event) {
	const trap = topTrap();
	if (!trap || inLayerOrAbove(trap, event.target)) return;
	focusFirst(trap.root);
}
function listen() {
	document.addEventListener("keydown", onKeyDown);
	document.addEventListener("pointerdown", onPointerDown, true);
	document.addEventListener("focusin", onFocusIn);
}
function unlisten() {
	document.removeEventListener("keydown", onKeyDown);
	document.removeEventListener("pointerdown", onPointerDown, true);
	document.removeEventListener("focusin", onFocusIn);
}
//#endregion
export { registerLayer };

//# sourceMappingURL=stack.js.map